import React from 'react';
import PropTypes from 'prop-types';

import { useTableHashData } from '../../../hooks/useTableHashData';
import ErrorPage from '../../error/ErrorPage';

function Content({ children }) {
  const { errorMessage } = useTableHashData();

  if (errorMessage) {
    return <ErrorPage />;
  }

  return children;
}

Content.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default Content;
